import { API_CONFIG } from './config';

const fetchAnalyticsResponse = async (
  endpoint: string,
  signal?: AbortSignal
): Promise<Response> => {
  const response = await fetch(`${API_CONFIG.BASE_URL}${endpoint}`, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    signal,
  });

  if (response.status === 401) {
    localStorage.removeItem('authData');
    localStorage.removeItem('currentProject');
    window.location.href = '/login';
  }

  return response;
};

export const getEfficiencyTrend = (
  projectId?: string,
  params: { days?: number; runType?: string } = {},
  signal?: AbortSignal
): Promise<Response> => {
  const search = new URLSearchParams();
  search.set('days', String(params.days ?? 30));
  if (projectId) search.set('project_id', projectId);
  if (params.runType) search.set('run_type', params.runType);

  return fetchAnalyticsResponse(`/analytics/efficiency-trend?${search.toString()}`, signal);
};

export const getServiceRiskHeatmap = (
  projectId?: string,
  params: { numRuns?: number; topServices?: number; runType?: string; currentRunId?: string } = {},
  signal?: AbortSignal
): Promise<Response> => {
  const search = new URLSearchParams();
  search.set('num_runs', String(params.numRuns ?? 5));
  search.set('top_services', String(params.topServices ?? 8));
  if (projectId) search.set('project_id', projectId);
  if (params.runType) search.set('run_type', params.runType);
  if (params.currentRunId) search.set('current_run_id', params.currentRunId);

  return fetchAnalyticsResponse(`/analytics/service-risk-heatmap?${search.toString()}`, signal);
};

export const getAverageTestDuration = (
  projectId: string,
  signal?: AbortSignal
): Promise<Response> =>
  fetchAnalyticsResponse(`/analytics/avg-test-duration?project_id=${projectId}`, signal);

export const getWhatIfComparison = (
  projectId?: string,
  params: { days?: number; runId?: string } = {},
  signal?: AbortSignal
): Promise<Response> => {
  const search = new URLSearchParams();
  search.set('days', String(params.days ?? 30));
  if (projectId) search.set('project_id', projectId);
  if (params.runId) search.set('run_id', params.runId);

  return fetchAnalyticsResponse(`/analytics/what-if-comparison?${search.toString()}`, signal);
};

export const getCarbonCumulative = (
  projectId: string,
  signal?: AbortSignal
): Promise<Response> =>
  fetchAnalyticsResponse(`/analytics/carbon-cumulative?project_id=${projectId}`, signal);
